import { ArrowRight2 } from "iconsax-reactjs";
import React from "react";
import ProductCard from "../../components/Card/ProductCard";
import AboutUs from "../../components/AboutUs";
import OurProducts from "../../components/OurProducts";
import Landing from "../../components/Landing";
import ChooseUs from "../../components/ChooseUs";
import Blog from "../../components/Blog";
import FAQAccordion from "../../components/FAQAccordion";
import Testimonial from "../../components/Testimonial";
import Team from "../../components/Team";
import ContactUs from "../../components/ContactUs";

function HomePage() {
  return (
    <div className="w-full">
      {/* LANDING */}
      <Landing />
      {/* ABOUT US */}
      <AboutUs />
      {/* OUR PRODUCTS */}
      <OurProducts />
      {/* WHY CHOOSE US */}
      <ChooseUs />
      {/* TEAM */}
      <Team />
      {/* TESTIMONIAL */}
      {/* <Testimonial /> */}
      {/* BLOG */}
      {/* <Blog /> */}
      {/* FAQ */}
      <FAQAccordion />
      {/* ContactUs */}
      <ContactUs />
    </div>
  );
}

export default HomePage;
